import { gql } from "apollo-boost";
import Error from 'components/alerts/Error';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import TicketQRScanner from 'components/ticket-scanner/modules/TicketQRScanner';
import * as React from 'react';
import { Subscription } from "react-apollo";
import Moment from "react-moment";
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from 'reactstrap';
import Input from 'reactstrap/lib/Input';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UIModalDuck from 'stores/ducks/ui/UIModal.duck';
import UserDucks from 'stores/ducks/User.duck';
import { Card } from '../../../components/common/card/Card';
import { checkInTicket, getByCode } from '../../../components/graphql/queries/ticket';
import { getTicketBankItemsAsString } from '../../../components/graphql/queries/ticketBank';
import { parseCodeFromURL } from '../../../components/ticket-scanner/methods';

import EventToolbar from 'pages/manage/events/detail/EventToolbar'

enum MethodOfInput {
	TEXT,
	CAMERA,
	SCANNER,
	NAME
}

interface IDashboardOverviewProps {

	isOpen?: boolean;
	token?: string;
	match?: any;
	user?: any;
	dispatch?: any;

}
class EventPrivateCheckInPage extends React.Component<
	IDashboardOverviewProps,
	{
		isLoading: boolean;
		checkInStarted: boolean;
		event: any;
		updateString: number;
		eventId?: string;
		isDropdownOpen: boolean;
		error: boolean;
		showResult: boolean;
		searchTerm: string;
		result: any[];
		checkInLogPresent: boolean;
		methodOfInput: MethodOfInput;
		currentTicketCode: string | null;
		inputValue: string | null;
		codeExternal?: string;
		codeFive?: string;
		checkedinCount?: number;
		totalCheckedIn?: number;
		totalBought?: number;
		openModal: boolean;
		errorMessage: string;
		ticket?: {
			code: string,
			status: string
			ticketComponents: any[];
			checkInLog?: any[];
		};
		ticketComponents?: any[];
		updateString2: number;
	}
	> {

	constructor(props) {
		super(props);

		this.state = {
			event: null,
			eventId: "",
			showResult: false,
			isLoading: true,
			openModal: false,
			updateString: 0,
			checkInStarted: false,
			isDropdownOpen: false,
			error: false,
			methodOfInput: MethodOfInput.CAMERA,
			currentTicketCode: null,
			inputValue: null,
			codeExternal: "",
			codeFive: "",
			result: [],
			checkedinCount: 0,
			totalCheckedIn: 0,
			totalBought: 0,
			ticket: {
				code: "",
				status: "",
				ticketComponents: [],
				checkInLog: []
			},
			ticketComponents: [],
			updateString2: 0,
			searchTerm: '',
			errorMessage: '',
			checkInLogPresent: false
		};


		this.handleFiveChange = this.handleFiveChange.bind(this);
		this.handleExternalChange = this.handleExternalChange.bind(this);
		this.handleScannedCode = this.handleScannedCode.bind(this);
		this.fetchCheckedInTicket = this.fetchCheckedInTicket.bind(this);
		this.handleTicketCheckIn = this.handleTicketCheckIn.bind(this);
		this.handleTicketCheckInInsideModal = this.handleTicketCheckInInsideModal.bind(this);
		this.handleRoleChange = this.handleRoleChange.bind(this)
		this.reloadData = this.reloadData.bind(this);
		this.searchByNameOrEmail = this.searchByNameOrEmail.bind(this);
		this.runSearch = this.runSearch.bind(this);
		this.splice = this.splice.bind(this);
	}

	public handleRoleChange(user: any) {
		this.props.dispatch(UserDucks.setUser(user));
		return undefined;
	}

	public splice(code: string) {
		const order = this.state.result.find((item) => {
			return item.code === code
		})

		if (order.totalCount === 1) {
			const arr = this.state.result.filter((item) => {
				return item.code !== code
			})
			this.setState({
				result: arr
			})
		}
	}

	public reloadData(e: any, num: number) {
		fetchGraphQL(
			`
						{
							event {
								 get(eventId:"${this.state.eventId}") {
									id
									name
									location
									endTime
									startTime
									timezoneOffset
								}
							}
						}
					`,
		).then(result => {
			if (result !== null) {
				const eventResult = result.event!.get;
				fetchGraphQL(getTicketBankItemsAsString(), undefined, {
					eventId: this.state.eventId,
				}).then((resultInventory: any) => {
					const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
					let totalCheckedIn: number = 0;
					let totalBought: number = 0;
					ticketInventory.map((item) => {
						totalCheckedIn += item.checkedIn;
						totalBought += item.bought;
					});
					if (num === 1) {
						this.setState({
							event: eventResult ? eventResult : null,
							totalCheckedIn,
							totalBought,
							updateString: e,
							isLoading: false
						});
					} else {
						this.setState({
							event: eventResult ? eventResult : null,
							totalCheckedIn,
							totalBought,
							updateString2: e,
							isLoading: false
						});
					}
				});

			} else {
				if (num === 1) {
					this.setState({
						isLoading: false,
						updateString: e
					});
				} else {
					this.setState({
						isLoading: false,
						updateString2: e
					});
				}
			}
		});
		return undefined;
	}

	public componentDidMount() {
		const { eventId } = this.props.match.params;
		this.setState({ eventId });
		fetchGraphQL(
			`
          {
            event {
               get(eventId:"${eventId}") {
                id
                name
                location
                endTime
                startTime,
				timezoneOffset
              }
            }
          }
        `,
		).then(result => {
			if (result !== null) {
				const eventResult = result.event!.get;
				fetchGraphQL(getTicketBankItemsAsString(), undefined, {
					eventId,
				}).then((resultInventory: any) => {
					const ticketInventory = JSON.parse(resultInventory.ticketBank.getAsString) || [];
					let totalCheckedIn: number = 0;
					let totalBought: number = 0;
					ticketInventory.map((item) => {
						totalCheckedIn += item.checkedIn;
						totalBought += item.bought;
					});
					this.setState({
						event: eventResult ? eventResult : null,
						totalCheckedIn,
						totalBought,
						isLoading: false
					});
				});
			} else {
				this.setState({
					isLoading: false
				});
			}
		});
	}

	public handleFiveChange(e: any) {
		const val: string = e.target.value;

		this.setState({
			codeFive: val
		}, () => {
			if (val.length >= 5) {
				this.setState({
					codeFive: ""
				});
				this.handleScannedCode(val);
			}
		});
	}

	public handleExternalChange(e: any) {
		const val: string = e.target.value;
		const maybeCode = parseCodeFromURL(val);

		this.setState({
			codeExternal: val
		}, () => {
			if (maybeCode !== false && maybeCode.length >= 5) {
				this.setState({
					codeExternal: ""
				}, () => {
					this.handleScannedCode(maybeCode);
				});
			}
		});
	}

	public handleScannedCode(code: string) {
		this.setState({
			checkInStarted: false,
			error: false,
		});
		fetchGraphQL(getByCode(),
			undefined,
			{ ticketCode: code }
		).then(result => {
			let checkInsLeft = 0;
			if (result !== undefined && result !== null) {
				const ticket = result.ticket !== null ? result.ticket.get : {};
				if ((ticket.status === "bought" || ticket.status === "partiallyCheckedIn" || ticket.status === "checkedIn")) {
					if (ticket.eventId !== this.state.eventId) {
						this.setState({
							error: true,
							errorMessage: 'Ticket belongs to another event!'
						})
					} else {
						const ticketComponents: any[] = [];
						ticket.ticketComponents.map((item: any) => {
							const count = item.count;
							const alreadyCheckedIn = item.checkedIn || 0;
							for (let i = 0; i < count; i++) {
								ticketComponents.push({
									name: item.name,
									ticketBankId: item.ticketBankId,
									checkedIn: i < alreadyCheckedIn ? true : false
								})
								if (i >= alreadyCheckedIn) {
									checkInsLeft++;
								}
							}
						});
						this.setState({
							ticket,
							ticketComponents,
							checkInStarted: true,
							checkInLogPresent: ticket.checkInLog ? true : false
						});
					}
				} else {
					this.setState({
						error: true,
						errorMessage: 'Unknown error occurerd!'
					})
				}
			} else {
				this.setState({
					error: true,
					errorMessage: 'Invalid QR code!'
				});
			}
			openModal(<div>{this.renderTicket()}</div>, String(checkInsLeft) + ' check-in(s) remaining for order ' + code + '!');
		});

	}

	public fetchCheckedInTicket(code: string) {
		fetchGraphQL(getByCode(),
			undefined,
			{ ticketCode: code }
		).then(result => {
			let checkInsLeft = 0;
			if (result !== undefined && result !== null) {
				const ticket = result.ticket !== null ? result.ticket.get : {};
				const ticketComponents: any[] = [];
				ticket.ticketComponents.map((item: any) => {
					const count = item.count;
					const alreadyCheckedIn = item.checkedIn || 0;
					for (let i = 0; i < count; i++) {
						ticketComponents.push({
							name: item.name,
							ticketBankId: item.ticketBankId,
							checkedIn: i < alreadyCheckedIn ? true : false
						})
						if (i >= alreadyCheckedIn) {
							checkInsLeft++;
						}
					}
				});
				this.setState({
					ticket,
					ticketComponents,
					error: false,
					checkInLogPresent: ticket.checkInLog ? true : false
				});
				if (ticket.totalCount !== 1) {
					openModal(<div>{this.renderTicket()}</div>, String(checkInsLeft) + ' check-in(s) remaining for order ' + code + '!');
				}
			}
		});
	}

	public runSearch(e: any) {
		this.setState({ searchTerm: e.target.value, showResult: false })
	}

	public searchByNameOrEmail() {
		if (this.state.searchTerm === '') {
			return;
		}
		fetchGraphQL(`
		query {
			ticket {
				searchByNameorEmailForCheckin(searchTerm:"${this.state.searchTerm}",eventId:"${this.state.eventId}") {
					code
					buyer {
						fullName
						email
					}
					totalCount
				}
			}
		}
		`).then(res => {
			this.setState({
				showResult: true,
				result: res.ticket.searchByNameorEmailForCheckin
			})
		})
	}

	public handleTicketCheckInInsideModal(e: any, code: string) {
		closeModal();
		const ticketBankId: string = e.target.value;
		const newTicketComponents: any[] = this.state.ticket!.ticketComponents;
		newTicketComponents.map((item: any) => {
			if (item.ticketBankId === ticketBankId) {
				if (item.checkedIn < item.count) {
					item.checkedIn++;
				}
				else {
					this.setState({
						error: true,
						errorMessage: 'An unknown error occured!'
					});
				}
			}
		});
		fetchGraphQL(checkInTicket(), undefined, {
			ticketCode: code,
			eventId: this.state.eventId,
			ticketComponents: newTicketComponents,
			newCheckedIn: {
				ticketBankId,
				count: 1
			}
		}).then(response => {
			if (
				response !== null &&
				response.ticket !== null &&
				response.ticket.checkIn === "true") {
				this.fetchCheckedInTicket(code);
				this.setState({
					totalCheckedIn: this.state.totalCheckedIn! + 1 || 1,
					openModal: true
				});
			}
			else {
				this.setState({
					error: true,
					errorMessage: 'An unknown error occured!'
				})
			}
		});
	}

	public handleTicketCheckIn(e: any, code: string) {
		const ticketBankId: string = e.target.value;
		const newTicketComponents: any[] = this.state.ticket!.ticketComponents;
		newTicketComponents.map((item: any) => {
			if (item.ticketBankId === ticketBankId) {
				if (item.checkedIn < item.count) {
					item.checkedIn++;
				}
				else {
					this.setState({
						error: true,
						errorMessage: 'An unknown error occured!'
					});
				}
			}
		});
		fetchGraphQL(checkInTicket(), undefined, {
			ticketCode: code,
			eventId: this.state.eventId,
			ticketComponents: newTicketComponents,
			newCheckedIn: {
				ticketBankId,
				count: 1
			}
		}).then(response => {
			if (response !== null && response.ticket !== null) {
				if (response.ticket.checkIn === "true") {
					this.fetchCheckedInTicket(code);
					this.setState({
						totalCheckedIn: this.state.totalCheckedIn! + 1 || 1
					});
				} else if (response.ticket.checkIn === "error-other") {
					this.setState({
						error: true,
						errorMessage: 'Ticket belongs to another event.'
					})
				} else if (response.ticket.checkIn === "error-invalid") {
					this.setState({
						error: true,
						errorMessage: 'Invalid QR code!'
					})
				} else {
					this.setState({
						error: true,
						errorMessage: 'An unknown error occured!'
					})
				}
			}
			else {
				this.setState({
					error: true,
					errorMessage: 'An unknown error occured!'
				})
			}
		});
	}

	public handleAllTicketsCheckIn(e: any, code: string) {
		const newTicketComponents: any[] = this.state.ticket!.ticketComponents;
		const newCheckedIn: any[] = [];
		let totalCheckIn: number = 0;
		newTicketComponents.map((item: any) => {
			newCheckedIn.push({
				ticketBankId: item.ticketBankId,
				count: item.count - item.checkedIn
			});
			totalCheckIn += item.count - item.checkedIn;
			item.checkedIn = item.count;
		});

		fetchGraphQL(checkInTicket(), undefined, {
			ticketCode: code,
			eventId: this.state.eventId,
			ticketComponents: newTicketComponents,
			newCheckedIn
		}).then(response => {
			if (response !== null && response.ticket !== null) {
				if (response.ticket.checkIn === "true") {
					this.fetchCheckedInTicket(code);
					this.setState({
						totalCheckedIn: this.state.totalCheckedIn! + totalCheckIn || totalCheckIn
					});
				} else if (response.ticket.checkIn === "error-other") {
					this.setState({
						error: true,
						errorMessage: 'Ticket belongs to another event.'
					})
				} else if (response.ticket.checkIn === "error-invalid") {
					this.setState({
						error: true,
						errorMessage: 'Invalid QR code!'
					})
				} else {
					this.setState({
						error: true,
						errorMessage: 'An unknown error occured!'
					})
				}
			}
			else {
				this.setState({
					error: true,
					errorMessage: 'An unknown error occured!'
				})
			}
		});
	}

	public dropdownToggle = () => {
		this.setState({
			isDropdownOpen: !this.state.isDropdownOpen,
		});
	};

	public changeMethod = (method: MethodOfInput) => {
		this.setState({
			methodOfInput: method,
			error: false,
		});
	};

	public renderInput = () => {
		switch (this.state.methodOfInput) {
			case MethodOfInput.SCANNER:
				return 'Scanner';
			case MethodOfInput.CAMERA:
				return 'camera';
			default:
				return (
					<input
						className='form-control'
						placeholder='Enter Ticket Code'
						onChange={this.handleCodeInputChange}
					/>
				);
		}
	};

	public handleCodeInputChange = (e: any) => {
		const val: string = e.target.value;

		this.setState({ inputValue: val }, () => {
			if (val.length === 5) {
				this.setState({ currentTicketCode: val, inputValue: null });
			}
		});
	};

	public renderTicket = () => {
		let checkerArr: any;
		if (this.state.checkInLogPresent) {
			checkerArr = JSON.parse(JSON.stringify(this.state.ticket!.checkInLog))
		}
		return (
			<div className="mb-2">
				<p />
				<div className={'div_holder_3'}>
					{this.state.error === true ? <Error content={this.state.errorMessage} />
						:
						<div>
							<div style={{ width: '100%', textAlign: 'center' }}>
								{this.state.ticket!.status === "bought" ? (
									<span className="badge badge-danger" style={{ backgroundColor: '#4d5ae9' }}>
										bought
									</span>
								) : this.state.ticket!.status === "partiallyCheckedIn" ? (
									<span className="badge badge-warning" style={{ backgroundColor: '#07ba76' }}>
										partially checked-in
									</span>
								) : (
											<span className="badge badge-success" style={{ backgroundColor: '#07ba76' }}>
												checked-in
											</span>
										)
								}
								<p><br /></p>
							</div>
							<table className="table">
								<tbody>
									{
										this.state.ticketComponents!.map((ticket, idx) => {
											// Code to see whether or not a log item is present and if it is then retrieve it
											let logItem: any;
											let found = false;
											if (this.state.checkInLogPresent && ticket.checkedIn) {
												const i = checkerArr.findIndex(item => {
													return ticket.ticketBankId === item.ticketBankId && item.count > 0
												})
												if (i !== -1) {
													logItem = checkerArr[i]
													checkerArr[i].count = checkerArr[i].count - 1;
													found = true;
												}
											}
											return (
												<tr key={"tk-" + ticket.name + idx}>
													<td className="text-left">
														{ticket.name}
														{
															found ? <small className="pause-gray">
																<br />
																{'By ' + logItem.checkerName + ' on '}
																<Moment format="M.D.Y">
																	{logItem.checkedInAt}
																</Moment>
																{" at "}
																<Moment format="hh:mm A">
																	{logItem.checkedInAt}
																</Moment>
															</small> : null
														}
													</td>
													<td className="text-right">
														{ticket.checkedIn ? (
															<button
																className="new-button-white-4"
																disabled={true}
																style={{ border: 'none', cursor: 'not-allowed', color: '#FF5244' }}
															>
																CHECKED-IN
															</button>
														) : (
																<button
																	className="new-button-white-4"
																	value={ticket.ticketBankId}
																	onClick={e => this.handleTicketCheckInInsideModal(e, this.state.ticket!.code)}
																	style={{ border: 'none', cursor: 'pointer' }}
																>
																	CHECK-IN
																</button>
															)}
													</td>
												</tr>
											);
										})}
									<tr style={{ paddingTop: '10px' }}>
										{
											this.state.ticketComponents!.length === 1 || this.state.ticket!.status === 'checkedIn' ?
												<td className="text-left" /> :
												<td className="text-left">
													{this.state.ticket!.status === "checkedIn" ?
														(
															<button
																className="new-button-blue-outline"
																disabled={true}
																style={{ border: 'none', cursor: 'not-allowed' }}
															>
																CHECKED-IN
															</button>
														) : (
															<button
																className="new-button-blue-gradient"
																style={{ border: 'none', cursor: 'pointer' }}
																onClick={e => this.handleAllTicketsCheckIn(e, this.state.ticket!.code)}
															>
																CHECK-IN ALL
															</button>
														)}
												</td>
										}
										<td className="text-right">
											<button
												className="new-button-blue-gradient"
												style={{ border: 'none', cursor: 'pointer' }}
												onClick={e => closeModal()}
											>
												DONE
												</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					}
				</div>
			</div >
		);
	};

	public render() {

		const roleChange = gql`
		subscription {
		  roleChange
		}
				`;

		const ticketPurchase = gql`
		subscription {
			ticketPurchase(eventIds:"${this.state.eventId}")
		}
		`;

		const ticketCheckin = gql`
		subscription {
			ticketCheckin(eventIds:"${this.state.eventId}")
		}
		`;

		if (this.state.isLoading) {
			return <div />;
		} else if (!this.state.isLoading && this.state.event === null) {
			return (
				<div
					className='p-3 w-100 text-center align-items-center align-content-center d-flex'
					style={{ minHeight: '100vh' }}
				>
					<div style={{ margin: '0 auto' }}>
						<h3>Event has not been found.</h3>
					</div>
				</div>
			);
		}

		return (
			<React.Fragment>
				<Subscription subscription={ticketPurchase}>
					{({ data }) => {
						if (data !== undefined && data !== null && data.ticketPurchase !== null) {
							if (data.ticketPurchase !== this.state.updateString) {
								return <img height={0} width={0} onLoad={this.reloadData(data.ticketPurchase, 1)} style={{ display: 'none' }} />
							}
							return null;
						}
						return null;
					}}
				</Subscription>
				<Subscription subscription={ticketCheckin}>
					{({ data }) => {
						if (data !== undefined && data !== null && data.ticketCheckin !== null) {
							if (data.ticketCheckin !== this.state.updateString2) {
								return <img height={0} width={0} onLoad={this.reloadData(data.ticketCheckin, 2)} style={{ display: 'none' }} />
							}
							return null;
						}
						return null;
					}}
				</Subscription>
				<Subscription subscription={roleChange}>
					{({ data }) => {
						if (data !== undefined && data !== null && data.roleChange !== null && data.roleChange.length !== 0) {

							const events = {}
							Object.keys(this.props.user.events).map((key) => {
								if (this.props.user.events[key].id === data.roleChange[1]) {
									events[key] = { id: this.props.user.events[key].id, roles: [data.roleChange[2]] }
								} else {
									events[key] = this.props.user.events[key]
								}
							});

							const newUser = {
								...this.props.user,
								events
							}
							this.handleRoleChange(newUser);
							return <Redirect to="/manage/events" />;
						}
						return null;
					}}
				</Subscription>

				<div className='div_holder_2'>
					<p />
					<EventToolbar
						eventId={this.state.event.id}
						checkin={true}
						eventName={this.state.event.name}
						key={this.props.user.id}
						userId={this.props.user.id}
					/>
					<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
						<Card style={{ width: 'auto', minWidth: '350px', paddingLeft: '10%', paddingRight: '10%' }}>
							<div>
								<p />
								<div className='col-md-12 p-2 mt-2 text-center'>
									<h4 className="sexyBlack">{this.state.event.name}</h4>
								</div>
								<p />
								<Dropdown
									isOpen={this.state.isDropdownOpen}
									className="new-button-white-3"
									style={{ width: '100px' }}
									onClick={e => this.dropdownToggle()}
								>
									<DropdownToggle
										tag="span"
										onClick={e => this.dropdownToggle()}
										data-toggle="dropdown"
										aria-expanded={this.state.isDropdownOpen}
										caret={true}
										style={{ borderRadius: '10vh' }}
									>
										{
											this.state.methodOfInput === MethodOfInput.TEXT ?
												"BY ID" : this.state.methodOfInput === MethodOfInput.SCANNER ?
													"HAND SCANNER" : MethodOfInput.NAME === this.state.methodOfInput ? "GUEST LIST" : "CAMERA"
										}
									</DropdownToggle>
									<DropdownMenu style={{ borderRadius: '20px' }}>
										<DropdownItem
											onClick={e => this.changeMethod(MethodOfInput.TEXT)}
										>
											BY ID
												</DropdownItem>
										<DropdownItem
											onClick={e => this.changeMethod(MethodOfInput.NAME)}
										>
											GUEST LIST
												</DropdownItem>
										<DropdownItem
											onClick={e => this.changeMethod(MethodOfInput.CAMERA)}
										>
											CAMERA
													</DropdownItem>
										{/* <DropdownItem
													onClick={e => this.changeMethod(MethodOfInput.SCANNER)}
												>
													HAND SCANNER
													</DropdownItem> */}
									</DropdownMenu>
								</Dropdown>
								<p />
								<div style={{ width: '100%' }}>
									<div style={{ width: '50%', float: 'left', textAlign: 'center' }}>
										<Label>Total Checked-in</Label>
										<h3>
											<span className='sexyBlack'>{this.state.totalCheckedIn}{' '}</span>
											<br />
											<small>
												{this.state.totalCheckedIn === 1 ? 'Ticket' : 'Tickets'}<br /></small>{' '}
										</h3>
									</div>

									<div style={{ width: '50%', float: 'right', textAlign: 'center' }}>
										<Label>Remaining</Label>
										<h3>
											<span className='sexyBlack'>{this.state.totalBought! - this.state.totalCheckedIn!}{' '}</span>
											<br />
											<small>
												{this.state.totalBought! - this.state.totalCheckedIn! === 1 ? 'Ticket' : 'Tickets'}<br /></small>{' '}
										</h3>
									</div>
								</div>
								<div style={{ width: '100%' }}>
									<p />
									<br />
									<p style={{ fontSize: '11px', textAlign: 'center', width: '100%' }}>
										<br />IOS users, please scan tickets using Safari. Android users, please scan tickets using Chrome.<br />
									</p>
									{this.state.methodOfInput === MethodOfInput.SCANNER ? (
										<div style={{ textAlign: 'center' }}>
											<div className="big-split" style={{ width: '50%', margin: '0 auto' }}>
												<p />
												<Input
													autoFocus={true}
													value={this.state.codeExternal}
													onChange={
														!document.body.classList.contains('Modal-open') ? this.handleExternalChange : () => { console.log('') }

													}
													className="text-center"
													placeholder="Use your scanner to provide input..."
												/></div>
											<div className="small-split">
												<Input
													autoFocus={true}
													value={this.state.codeExternal}
													onChange={
														!document.body.classList.contains('Modal-open') ? this.handleExternalChange : () => { console.log('') }
													}
													className="text-center"
													placeholder="Use your scanner to provide input..."
												/>
											</div>
										</div>
									) : null}
									{this.state.methodOfInput === MethodOfInput.TEXT ? (
										<div style={{ textAlign: 'center' }}>
											<div className="big-split" style={{ width: '50%', margin: '0 auto' }}>
												<p><br /></p>
												<Input
													placeholder="Enter 5 digit ticket ID (xxxxx)..."
													autoFocus={true}
													value={this.state.codeFive}
													onChange={this.handleFiveChange}
													className="text-center"
													style={{ backgroundColor: '#ebecf1', borderRadius: '10px', height: '27px', fontSize: '15px', paddingRight: '4px' }}
												/>
											</div>
											<div className="small-split">
												<Input
													placeholder="Enter 5 digit ticket ID (xxxxx)..."
													autoFocus={true}
													value={this.state.codeFive}
													onChange={this.handleFiveChange}
													className="text-center"
													style={{ backgroundColor: '#ebecf1', borderRadius: '10px', height: '27px', fontSize: '15px', paddingRight: '4px' }}

												/>
											</div>
										</div>
									) : null}
									{this.state.methodOfInput === MethodOfInput.CAMERA ? (
										<div style={{ borderRadius: '10px', paddingTop: '20px' }}>
											<TicketQRScanner onSuccess={!document.body.classList.contains('Modal-open') ? this.handleScannedCode : () => { console.log('') }} />
										</div>
									) : null}
									{
										this.state.methodOfInput === MethodOfInput.NAME ? (
											<div>
												<div style={{ width: '100%' }}>
													<div style={{ justifyContent: 'center', display: 'flex' }}>
														<div style={{ width: screen.width > 768 ? '50%' : '85%', paddingBottom: '20px' }}>
															<p />
															<div>
																<div style={{ width: '80%', float: 'left' }}>
																	<Input
																		type="text"
																		name="search"
																		id="search"
																		placeholder="name or email"
																		style={{ backgroundColor: '#ebecf1', borderRadius: '10px', height: '27px', fontSize: '15px', paddingRight: '4px' }}
																		value={this.state.searchTerm}
																		onChange={(e) => {
																			e.preventDefault();
																			this.runSearch(e);
																		}}
																	/>
																</div>
																<div style={{ width: '17%', float: 'right' }}>
																	<div
																		className='new-button-white-4'
																		onClick={e => {
																			e.preventDefault()
																			this.searchByNameOrEmail();
																		}
																		}
																	>
																		SEARCH
                                            			</div>
																</div>
															</div>
														</div>
													</div>
													{
														this.state.showResult ?
															<div style={{ display: 'flex', justifyContent: 'center' }}>
																<div style={{
																	overflowX: "scroll"
																}}>
																	<table className='table-responsive--base m-0' style={{ minWidth: '300px' }}>
																		<thead>
																			<tr>
																				<td>NAME</td>
																				<td>EMAIL</td>
																				<td>TICKET ID</td>
																				<td>&nbsp;</td>
																			</tr>
																		</thead>
																	</table>
																	<div style={{ maxHeight: '400px' }}>
																		<table className='table-responsive--base' style={{ minWidth: '300px', overflowX: 'scroll' }}>
																			<tbody>
																				{this.state.result.length > 0 ? (
																					this.state.result.map((ticket) => {
																						return (
																							<tr key={'ticket-item-' + ticket.code}>
																								<td data-label={'Customer'} className="sexyBlack">
																									{ticket.buyer ? ticket.buyer.fullName : '-'}
																								</td>
																								<td data-label={'Email'}>
																									{ticket.buyer ? ticket.buyer.email : '-'}
																								</td>
																								<td data-label={'code'}>
																									{ticket.code || '-'}
																								</td>
																								<td data-label={'button'}>
																									<button
																										onClick={e => {
																											this.handleScannedCode(ticket.code)
																											this.splice(ticket.code)
																										}
																										}
																										className="new-button-white-4"
																										style={{
																											border: 'none'
																										}}
																									>
																										CHECK-IN
                                                                    								</button>
																								</td>
																							</tr>
																						)
																					})) :
																					<tr>
																						<td colSpan={7}>No tickets.</td>
																					</tr>
																				}
																			</tbody>
																		</table>
																	</div>
																</div>
															</div>
															: null
													}
												</div>
											</div>
										) : null
									}
									<p><br /></p>
								</div>
							</div>
							<p />
						</Card>
					</div>

				</div>
			</React.Fragment >
		);
	}
}

const mapStateToProps = state => {
	return {
		isLoggedIn: UserDucks.isAuthenticated(state),
		user: UserDucks.getUser(state),
		isOpen: UIModalDuck.isOpen(state)
	};
};

export default connect(mapStateToProps)(EventPrivateCheckInPage);



// WEBPACK FOOTER //
// ./src/pages/event/private/CheckIn.page.tsx